/* global graphql */
import React from 'react';

import SessionBroadcastManager from '../models/SessionBroadcastManager';

import BleepShop from '../components/BleepShop.jsx';
import SessionItems from '../components/SessionItems.jsx';
import LivePlayer from '../components/LivePlayer';
import CookiesFooter from '../components/CookiesFooter';

import Icon from '../components/icon';
import NtsIcon from '../components/icon/nts-logo.icon';
import ChatIcon from '../components/icon/icons-chat.icon';

class IndexPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sessionBroadcastManager: null,
        };
    }

    componentDidMount() {
        this.setState({
            sessionBroadcastManager: new SessionBroadcastManager(this.props.data.allDataJson.edges[0].node.broadcasts),
        });
    }

    _logClick(action) {
        if (typeof ga !== "undefined") ga('send', 'event', 'Autechre', action);
    }

    render() {
        const shopHostUrl = this.props.data.allDataJson.edges[0].node.shopHostUrl;
        const shopBundleUrl = this.props.data.allDataJson.edges[0].node.shopBundleUrl;

        return (
            <div id="page-container">
                <div id="header">
                    <div className="header__left">
                        <a className="header__left__nts-logo" href="https://www.nts.live" target="_blank" rel="noopener noreferrer"
                            onClick={() => this._logClick('GoTo-NTS')}>
                            <Icon icon={NtsIcon} />
                        </a>

                        <a className="header__left__autechre-text text-bold" href="https://autechre.bleepstores.com/" target="_blank" rel="noopener noreferrer"
                            onClick={() => this._logClick('GoTo-Autechre')}>
                            Autechre
                        </a>
                    </div>

                    <div className="header__centre hidden-mobile">
                        <a className="header__center__chat" href="https://nts-residency.chatango.com/" target="_blank" rel="noopener noreferrer"
                            onClick={() => this._logClick('GoTo-Chat')}>
                            <Icon icon={ChatIcon} />
                        </a>
                    </div>

                    <div className="header__right">
                        <a className="nts-btn text-uppercase" href={shopBundleUrl} target="_blank" onClick={() => this._logClick("GoTo-BoxSet")}>BUY BOX SET</a>
                    </div>
                </div>

                <div id="page-content">
                    {!!this.state.sessionBroadcastManager && (
                        <div>
                            <LivePlayer sessionBroadcastManager={this.state.sessionBroadcastManager} />

                            <div className="session-items-container">
                                <SessionItems sessionBroadcastManager={this.state.sessionBroadcastManager} shopBundleUrl={shopBundleUrl} />
                            </div>
                        </div>
                    )}
                </div>

                <CookiesFooter />

                <div id="footer-copy">
                    Autechre take over NTS Radio for a month-long residency throughout April 2018, <br className="hidden-mobile"/>presenting four two-hour shows of new and original Autechre music.
                </div>

                <div id="footer">
                    {!!this.state.sessionBroadcastManager && (
                        <BleepShop sessionBroadcasts={this.state.sessionBroadcastManager.broadcasts} shopHostUrl={shopHostUrl} />
                    )}
                    <a className="footer__checkout-btn hidden-desktop" href={shopHostUrl + '/cart/index'} target="_blank">Checkout</a>
                </div>
            </div>
        );
    }
}

export default IndexPage;

export const pageQuery = graphql`
  query IndexQuery {
    allDataJson {
      edges {
        node {
          broadcasts {
            name
            broadcastStart
            sourceUrl
            shopItems {
              id
            }
          }
          shopHostUrl
          shopBundleUrl
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js